exports = module.exports = require("./../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".note-list-placeholder{margin-bottom:23px}.note-list-placeholder .avatar{animation:loading-fade 1.6s ease-in-out infinite;background-color:#e9eff3;color:transparent;width:48px;height:48px}.note-list-placeholder .avatar:after{content:'\\A0'}.note-list-placeholder .subject{animation:loading-fade 1.6s ease-in-out infinite;background-color:#e9eff3;color:transparent;margin-top:-48px;margin-left:50px;min-height:18px}.note-list-placeholder .subject:after{content:'\\A0'}.note-list-placeholder .excerpt{animation:loading-fade 1.6s ease-in-out infinite;background-color:#fafbfc;color:transparent;margin-left:50px;margin-top:4px;min-height:12px}.note-list-placeholder .excerpt:after{content:'\\A0'}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./~/autoprefixer-loader!./src/list-view-placeholder.scss
 ** module id = 389
 ** module chunks = 0
 **/